export const SET_ISSUE = 'SET_ISSUE'
export const SET_ISSUES = 'SET_ISSUES'
export const UPDATE_ISSUE = 'UPDATE_ISSUE'



// WEBPACK FOOTER //
// ./src/store/modules/issues/types.js